import { axInst, axInstBasic } from "../Service/Service";

export const fetchRetosCount = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}retroPendingCont`,
      { arn }
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchActiveAMCCount = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}vehicleActiveAMCcount`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchvehicleAMcCountDetails = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}vehicleAMcCountDetails`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchlastPurchahed = async (arn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}lastPurchahed`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};



export const fetchlastservicetb = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}lastServiceDateTable`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchopencompnestedtable = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}insightOccDetails`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchamcdue = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}amcContractDueNextOneMData`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchsampoornaTotalCouponIssued = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}sampoornaTotalCouponIssued`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchsampoornaTotalCouponGenerated = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}sampoornaTotalCouponGenerated`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchsampoornaTotalCouponBalance = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}sampoornaTotalCouponBalance`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchsampoornaTotalCouponExpired = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}sampoornaTotalCouponExpired`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};



export const fetchvehiclesevenyearstable = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ownershipLoadTable`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }

};




export const fetchtotalChassisTable = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}totalChassisTable`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchamcContTable = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}amcContTable`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchsampoornatableDataOnTime = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}sampoornatableDataOnTime`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchsampoornatableDataMoreTime = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}sampoornatableDataMoreTime`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};



export const fetchamcduedetailModalBody = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}amcduedetailModalBody`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchVehicalsInsights = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}VehicalsInsights`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};






export const fetchamcValidContTable = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}amcValidContTable`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchamcExpiredContTable = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}amcExpiredContTable`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchamcNonValidContTable = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}amcNonValidContTable`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};

















export const fetchdelaycards = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}sampoornaMoreTime`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchsixqtytable = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}sixMonthPurchaseQuantityData`,
      payload
    );
    return res.data;

  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchontime = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}sampoornaOnTimeCnt`,
      payload
    );
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchsampoornaTotalCouponVailed = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}sampoornaTotalCouponVailed`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchvehiclesInsuranceExpeNintydays = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}insurance_data`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchamcContractDueNextOneMData = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}amcContractDueNextOneMData`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};




export const fetchlastServiceDateLoad = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}lastServiceDateLoad`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchtotalComplaintsStatusOpen = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}totalComplaintsStatusOpen`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchsixMonthPurchaseQuantity = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}sixMonthPurchaseQuantity`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchamcduecontracttable = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}amcContractDueDetails`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};



export const fetchoprencomptable = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}insightOccTable`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchcouponissuedtb = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}chassisNoNdVehicleRegNo`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchownershipLoadCount = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}ownershipLoadCount`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchproblemAreaWithDistinctChassis = async (arn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}problemAreaWithDistinctChassis`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchtotalVehicalsInsights = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}totalVehicalsInsights`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const fetchretropendingcount = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}retro_pending_count`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchretropendingtabledata = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}retro_pending_table_data`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};



export const fetchfreeServiceDataOnTable = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}freeServiceDataOnTable`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchfreeSeriveCount = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}freeSeriveCount`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchinsightsproblem = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}insights_problem_area`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};




export const fetchtataalerttabledetails = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}tataalerttabledetails`,
      payload
    );
    return res;

  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchttatakavachTableDetails = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}tatakavachTableDetails`,
      payload
    );
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchtataonZippyTableDetails = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}tatazippyTableDetailsOnTime`,
      payload
    );
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchZippyTableDetail = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}tataZippyTableDetails`,
      payload
    );
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchtataAlertTableDetailsOnTime = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}tataAlertTableDetailsOnTime`,
      payload
    );
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchtataKavachTableDetailsOnTime = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}tataKavachTableDetailsOnTime`,
      payload
    );
    return res;
  } catch (error) {
    console.error(error);
    throw error;
  }
};




export const fetchamcvalidcount = async (payload) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}amc_valid_count`,
      payload
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchamctable = async (arn) => {
  try {
    const res = await axInst.post(
      `${process.env.REACT_APP_API_URL}amc_table_data`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const fetchvehiclesevennestedtable = async (arn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}ownershipDetails`,
      arn
    );
    return res.data.result;
  } catch (error) {
    console.error(error);
    throw error;
  }
};




export const fetchontimetb = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}sampoornatableDataOnTime`,
      payload
    );
    return res.data.tata_on_time_total;
    ;
  } catch (error) {
    console.error(error);
    throw error;
  }
};


export const fetchSampoornaDataOnTime = async (payload) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}sampoornatableDataOnTime`,
      payload
    );
    return res.data.tata_more_time_total;
    ;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
